// Путь: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminVouchers\AdminVoucherTemplates.jsx
// Версия: 2.0.0 - Static themes with preview images
// Дата: 03.12.2025

import React, { useState } from 'react';
import './AdminVouchers.css';

// Статичные темы (те же что в CreateVoucher)
const THEMES = [
  { id: 'default', title: 'Обычный', emoji: '🎫' },
  { id: 'birthday', title: 'День рождения', emoji: '🎂' },
  { id: 'love', title: 'С любовью', emoji: '❤️' },
  { id: 'thanks', title: 'Спасибо', emoji: '🙏' },
  { id: 'gift', title: 'Подарок', emoji: '🎁' },
  { id: 'congrats', title: 'Поздравляю', emoji: '🎉' },
  { id: 'coffee', title: 'На кофе', emoji: '☕' },
  { id: 'lunch', title: 'На обед', emoji: '🍽️' },
  { id: 'travel', title: 'Путешествие', emoji: '✈️' },
  { id: 'gaming', title: 'На игры', emoji: '🎮' },
  { id: 'shopping', title: 'Шоппинг', emoji: '🛍️' },
  { id: 'newyear', title: 'Новый год', emoji: '🎄' },
];

// Бизнес-темы (дополнительные)
const BUSINESS_THEMES = [
  { id: 'corporate', title: 'Корпоративный', emoji: '🏢' },
  { id: 'employee', title: 'Сотруднику', emoji: '👔' },
  { id: 'partner', title: 'Партнёру', emoji: '🤝' },
  { id: 'client', title: 'Клиенту', emoji: '⭐' },
  { id: 'bonus', title: 'Бонус', emoji: '💰' },
  { id: 'promo', title: 'Промо', emoji: '🎯' },
];

const AdminVoucherTemplates = () => {
  const [selectedTheme, setSelectedTheme] = useState(null);

  const getImageUrl = (themeId) => {
    return `/templates/${themeId}.png`;
  };

  return (
    <div className="admin-vouchers">
      <div className="admin-page-header">
        <h1 className="admin-page-title">🎨 Темы подарков</h1>
        <div className="admin-theme-stats">
          <span className="admin-badge admin-badge-active">{THEMES.length} стандартных</span>
          <span className="admin-badge admin-badge-claimed">{BUSINESS_THEMES.length} бизнес</span>
        </div>
      </div>

      {/* Информация */}
      <div className="admin-card admin-info-card">
        <p>
          <strong>ℹ️ Как работают темы:</strong> Пользователи выбирают тему при создании подарка. 
          Тема определяет фоновое изображение карточки. Сумму и срок действия пользователь выбирает сам.
        </p>
      </div>

      {/* Стандартные темы */}
      <h3 className="admin-section-title">🎫 Стандартные темы ({THEMES.length})</h3>
      <div className="admin-themes-grid">
        {THEMES.map((theme) => (
          <div 
            key={theme.id} 
            className={`admin-theme-card ${selectedTheme === theme.id ? 'selected' : ''}`}
            onClick={() => setSelectedTheme(theme.id === selectedTheme ? null : theme.id)}
          >
            <div className="admin-theme-preview">
              <img 
                src={getImageUrl(theme.id)} 
                alt={theme.title}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="admin-theme-fallback" style={{display: 'none'}}>
                <span>{theme.emoji}</span>
              </div>
            </div>
            <div className="admin-theme-info">
              <span className="admin-theme-emoji">{theme.emoji}</span>
              <span className="admin-theme-title">{theme.title}</span>
              <code className="admin-theme-code">{theme.id}</code>
            </div>
          </div>
        ))}
      </div>

      {/* Бизнес темы */}
      <h3 className="admin-section-title">🏢 Бизнес темы ({BUSINESS_THEMES.length})</h3>
      <div className="admin-themes-grid">
        {BUSINESS_THEMES.map((theme) => (
          <div 
            key={theme.id} 
            className={`admin-theme-card business ${selectedTheme === theme.id ? 'selected' : ''}`}
            onClick={() => setSelectedTheme(theme.id === selectedTheme ? null : theme.id)}
          >
            <div className="admin-theme-preview">
              <img 
                src={getImageUrl(theme.id)} 
                alt={theme.title}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="admin-theme-fallback" style={{display: 'none'}}>
                <span>{theme.emoji}</span>
              </div>
            </div>
            <div className="admin-theme-info">
              <span className="admin-theme-emoji">{theme.emoji}</span>
              <span className="admin-theme-title">{theme.title}</span>
              <code className="admin-theme-code">{theme.id}</code>
              <span className="admin-theme-badge">PRO</span>
            </div>
          </div>
        ))}
      </div>

      {/* Превью выбранной темы */}
      {selectedTheme && (
        <div className="admin-card admin-preview-card">
          <h3>👁️ Превью темы: {selectedTheme}</h3>
          <div className="admin-preview-image">
            <img src={getImageUrl(selectedTheme)} alt={selectedTheme} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminVoucherTemplates;